import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle } from "lucide-react";
import { FlatTab, type FlatTabItem } from "@/components/FlatTab";

interface Step {
  number: number;
  label: string;
  active: boolean;
  completed?: boolean;
}

export const EditEvent = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const getStepsForRoute = (pathname: string): Step[] => {
    if (pathname.includes("/live-event")) {
      return [
        {
          number: 1,
          label: t("editEvent.tabs.chooseEvent"),
          active: false,
          completed: true,
        },
        {
          number: 2,
          label: t("editEvent.tabs.liveEvent"),
          active: true,
        },
      ];
    }

    if (pathname.includes("/game")) {
      return [
        {
          number: 1,
          label: t("editEvent.tabs.chooseEvent"),
          active: false,
          completed: true,
        },
        {
          number: 2,
          label: t("editEvent.tabs.gameEvent"),
          active: true,
        },
      ];
    }

    return [
      {
        number: 1,
        label: t("editEvent.tabs.chooseEvent"),
        active: true,
      },
    ];
  };

  const steps = getStepsForRoute(location.pathname);

  const tabItems: FlatTabItem[] = steps.map((step) => ({
    label: step.label,
    active: step.active,
    completed: step.completed,
    number: step.number,
    icon: step.completed ? <CheckCircle className="h-5 w-5" /> : undefined,
  }));

  return (
    <div className="min-h-screen bg-background">
      <div className="w-full pt-6 pr-6 pl-8">
        <h1 className="mb-4 text-2xl font-semibold text-foreground">
          {t("editEvent.newEvent.title")}
        </h1>
      </div>

      <div className="ml-8">
        <FlatTab items={tabItems} />
      </div>

      <div className="w-full border-b border-border"></div>

      <div className="px-8 pt-8">
        <Outlet />
      </div>
    </div>
  );
};
